import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ILoggedUser } from "../headerandnavigation/loggeduser/loggeduser";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { FormControlName, FormGroup, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { IChangePassword, IForceChangePassword, IUser } from "../users/user";
import { GenericValidator } from "../shared/generic-validator";
import { Observable } from "rxjs/Observable";
import { UserService } from "../users/user.service";
import { IAccount } from "../headerandnavigation/accounts/account";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
  templateUrl: "./accountdashboard.component.html"
})
export class AccountDashboardComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  msgs = [];
  loggedUser: ILoggedUser;
  user: IUser;
  account: IAccount;
  public pageTitle: string = 'My Fuel Card Account';
  changePasswordForm: FormGroup;
  changePassword: IChangePassword;
  displayMessageChangePassword: { [key: string]: string } = {};
  private validationMessagesChangePassword: { [key: string]: { [key: string]: string } };
  private genericValidatorChangePassword: GenericValidator;

  public teleganceAd = "show";
  public myServiceExpertAd = "show";
  public myDriveSafeExpertAd = "show";
  public milageCountAd = "show";

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public headerAndNavigationService: HeaderAndNavigationService,
    public userService: UserService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageName = this.pageTitle;
    this.appCommonService.pageContentAdditionalClass = "dashboard-page";
    this.validationMessagesChangePassword = {
      oldPassword: {
        required: 'Old Password is required.'
      },
      newPassword: {
        required: 'New Password is required.'
      },
      confirmPassword: {
        required: 'Confirm Password is required.'
      }
    };
    this.genericValidatorChangePassword = new GenericValidator(this.validationMessagesChangePassword);
  }

  ngOnInit() {
    this.headerAndNavigationService.showhideNav(false, true);
    this.changePasswordForm = this.fb.group({
      id: '',
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      //confirmPassword: ['', [Validators.required]]
      confirmPassword: ''
    });
    // this.msgs =[];
    // this.msgs.push({severity:'success', summary:'Success Message', detail:'Order submitted'});
    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    //debugger;
    if (this.loggedUser == null) {
      this.headerAndNavigationService.RedirectToLogin();
    }
    this.account = this.authService.getFirstSelectedAccessAccount();
    if (this.loggedUser != null && this.loggedUser.applications_access != null && this.loggedUser.applications_access != undefined) {
      var applications_accessArray = JSON.parse("[" + this.loggedUser.applications_access + "]");


      applications_accessArray.forEach(x => {
        x.forEach(y => {
          if (y == 1) {
            this.milageCountAd = "hide";
          }
          if (y == 2) {
            this.teleganceAd = "hide";
          }
          if (y == 3) {
            this.myDriveSafeExpertAd = "hide";
          }
          if (y == 4) {
            this.myServiceExpertAd = "hide";
          }
        })


      });


      //this.loggedUser.applications_access.forEach(x => {
      //  if (x == "1") {
      //    this.milageCountAd = "hide";
      //  }
      //  if (x == "2") {
      //    this.teleganceAd = "hide";
      //  }
      //  if (x == "3") {
      //    this.myDriveSafeExpertAd = "hide";
      //  }
      //  if (x == "4") {
      //    this.myServiceExpertAd = "hide";
      //  }

      //});

    }
  }

  ngAfterViewInit() {
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.changePasswordForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessageChangePassword = this.genericValidatorChangePassword.processMessages(this.changePasswordForm);
    });

    const selfMe = this;
    $('#welcomeModal').on('hidden.bs.modal', function () {
      selfMe.closeWelcomeWindow();
    });
  }

  showInitialPopUps() {
    if (this.loggedUser.displayWelcomeFlag) {
      $('#welcomeModal').modal('show');
    }
    else if (this.loggedUser.forcePasswordChange) {
      $('#forcePasswordChangeModal').modal('show');
    }
  }

  closeWelcomeWindow() {
    $('#welcomeModal').modal('hide');
    if (this.loggedUser.forcePasswordChange) {
      $('#forcePasswordChangeModal').modal('show');
    }
    this.getUserForWelcomeFlag(this.loggedUser.id);
  }

  closePasswordChangeWindow() {
    $('#forcePasswordChangeModal').modal('hide');
  }

  changePasswordSubmit(): void {
    if (this.changePasswordForm.valid) {
      // Copy the form values over the product object values
      this.changePasswordForm.patchValue({
        id: this.loggedUser.id,
      });
      let p = Object.assign({}, this.changePassword, this.changePasswordForm.value);
      this.loaderService.display(true);
      this.userService.updateUserForcePassword(p)
        .subscribe(
          () => {
            this.getUser(this.loggedUser.id);
          },
          (error: any) => {
            this.loaderService.display(false);
            this.userService.showError("Change Password", <any>error, true);
          }
        );
    } else if (!this.changePasswordForm.dirty) {
      this.reSetChangePasswordForm();
      $('#forcePasswordChangeModal').modal('hide');
    }
  }

  reSetChangePasswordForm() {
    this.changePasswordForm.reset();
  }

  getUser(id: string): void {
    this.userService.getUser(id)
      .subscribe(
        (user: IUser) => {
          //user.displayWelcomeFlag = false;
          user.forcePasswordChange = false;
          user.email = (user.email !== null ? user.email.replace(" (duplicate email)", "") : "");
          this.saveUser(user);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.userService.showError("User retrieval problem", <any>error);
          this.headerAndNavigationService.RedirectToLogin();
        }
      );
  }

  getUserForWelcomeFlag(id: string): void {
    this.userService.getUser(id)
      .subscribe(
        (user: IUser) => {
          user.displayWelcomeFlag = false;
          user.email = (user.email !== null ? user.email.replace(" (duplicate email)", "") : "");
          this.saveUserForWelcomeFlag(user);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.userService.showError("User retrieval problem", <any>error);
          this.headerAndNavigationService.RedirectToLogin();
        }
      );
  }

  saveUserForWelcomeFlag(user: IUser): void {
    this.userService.saveUser(user)
      .subscribe(
        () => {
          //this.userService.showSuccess("Welcome Flag", "Updated successfully.");
        },
        (error: any) => {
          this.userService.showError("User update problem", <any>error, true);
        }
      );
  }

  saveUser(user: IUser): void {
    //$('#forcePasswordChangeModal').modal('hide');
    //this.loaderService.display(false);
    //this.reSetChangePasswordForm();
    //this.userService.showSuccess("Change Password", "Password changed successfully.");

    this.userService.saveUser(user)
      .subscribe(
        () => {
          $('#forcePasswordChangeModal').modal('hide');
          this.loaderService.display(false);
          this.reSetChangePasswordForm();
          this.userService.showSuccess("Change Password", "Password changed successfully.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.userService.showError("User update problem", <any>error, true);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/accountdashboard.component.ts